common.View.create('admin.calendar.Index', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        this.element
            .find('.crud\\:\\:form-inputs-Date .prepend')
                .css({ cursor: 'pointer' })
                .click(() => this.element.find('.crud\\:\\:form-inputs-Date input').focus());
    }

});
